import { render, staticRenderFns } from "./love.vue?vue&type=template&id=c263c772&scoped=true"
import script from "./love.vue?vue&type=script&lang=js"
export * from "./love.vue?vue&type=script&lang=js"
import style0 from "./love.vue?vue&type=style&index=0&id=c263c772&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c263c772",
  null
  
)

export default component.exports